import {
  ITierPattern,
  SmartPairedBayBlock,
  SmartUnpairedBayBlock,
} from "@tedivo/tedivo-bay-grid-pure";

import { IDeckSelectContainerCriteria } from "../useSimpleDeckView";
import { TGetContainersFilterOutput } from "./TGetContainersFilterOutput";
import { getContainersByHighestAbove } from "./getContainersByHighestAbove";
import { getContainersByHighestAll } from "./getContainersByHighestAll";
import { getContainersByHighestBelow } from "./getContainersByHighestBelow";
import { getContainersByHighestBelowOrLowestAbove } from "./getContainersByHighestBelowOrLowestAbove";
import { getContainersByTier } from "./getContainersByTier";

export function obtainDeckViewFilterFn(
  selectContainerCriteria: IDeckSelectContainerCriteria,
): TObtainFilterFnOutput {
  switch (selectContainerCriteria) {
    case "highestBelowOrLowestAbove":
      return getContainersByHighestBelowOrLowestAbove;
    case "highestAll":
      return getContainersByHighestAll;
    case "highestBelow":
      return getContainersByHighestBelow;
    case "highestAbove":
      return getContainersByHighestAbove;
    default:
      return getContainersByTier(selectContainerCriteria as ITierPattern);
  }
}

/**
 * `allBlocks` is every block of the vessel. The blocks are split by level, and
 * a criterion that spans levels ("highest overall") needs the above-deck block
 * of a below-deck one; the others ignore it.
 */
type TObtainFilterFnOutput = (
  smartBay: SmartUnpairedBayBlock | SmartPairedBayBlock,
  allBlocks: Array<SmartUnpairedBayBlock | SmartPairedBayBlock>,
) => TGetContainersFilterOutput;
